import React from "react";
import { Count, CountCircle } from "./NotificationCountStyles";

export default function NotificationCount({
  numNotifications,
}: {
  numNotifications?: number;
}) {
  if (numNotifications === undefined || numNotifications === 0) {
    return null;
  }
  return (
    <CountCircle>
      <Count>{numNotifications}</Count>
    </CountCircle>
  );
}
